var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.elementType, {
    tag: "component",
    class: _vm.customClass,
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.clickEvent
    }
  }, [_vm._v("\n  " + _vm._s(_vm.translations[_vm.keyTranslation] || _vm.text) + "\n  "), _vm._t("child")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }